// extracted by mini-css-extract-plugin
module.exports = {"countdown":"nf-z","srOnly":"of-z"};